import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ApiVersionService {
	shouldRefresh$ = new Subject<boolean>();
	private apiVersion: string;

	checkApiVersion(responseApiVersion: string): void {
		if (!responseApiVersion) {
			return;
		}
		if (this.apiVersion === undefined) {
			this.apiVersion = responseApiVersion;
		}
		if (this.apiVersion !== responseApiVersion) {
			this.shouldRefresh$.next(true);
		}
	}

	getApiVersion(): string {
		return this.apiVersion;
	}
}
